// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader } from '@datagraphics/cookbook';
import { load, lazyload, observer } from './lazyload-update.js';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

//// Write your code!
//-------------------"INFINITE SCROLL"---------------------//

const container = document.querySelector('#container-container');
let loaded = parseInt(container.dataset.loaded);

let ofrendaNav = document.querySelector('#ofrenda-nav');

const filters = {
  pets: function (entry) {
    return false;
    // return (!entry.type)||entry.type=='pet';
  },
  people: function (entry) {
    return !entry.type || entry.type == 'person';
  },
  all: function (entry) {
    return true;
  },
};

let currentFilter = 'Person';

//intersection observer ------
let timer = undefined;

const intOptions = {
  root: null,
  rootMargin: '0px 0px 0px 0px',
  threshold: 0,
};

const bottomObserver = new IntersectionObserver(checkIntersection, intOptions);
const trigger = document.querySelector('#load-trigger');
const cloner = document.querySelector('#hide-for-cloning .card');

bottomObserver.observe(trigger);
bottomObserver.observe(container);

function checkIntersection(entries) {
  entries.forEach((entry, i) => {
    let id = entry.target.id;
    // let filtered=ofrendas.filter(currentFilter);
    if (
      id == 'load-trigger' &&
      entry.intersectionRatio > 0 &&
      loaded < ofrendas?.filter(filterOfrendas).length
    ) {
      //buffer
      if (timer !== undefined) clearTimeout(timer);
      timer = setTimeout(loadMoreOfrendas, 1000);
    }

    if (id == 'container-container' && entry.intersectionRatio > 0) {
      ofrendaNav.classList.add('slidein');
      document.querySelector('footer')?.classList.add('sticky-footer');
    } else if (id == 'container-container') {
      document.querySelector('footer')?.classList.remove('sticky-footer');
      ofrendaNav.classList.remove('slidein');
      document.querySelector('#bottom-drawer').classList.remove('open');
      document.querySelector('article').classList.remove('drawer-up');
      let openButton = document.querySelector('#open-drawer');
      openButton.innerText = openButton.dataset.closed;
    }
  });
}

document.querySelector('#go-top').addEventListener('click', function () {
  document
    .querySelector('#ofrenda-header')
    .scrollIntoView({ behavior: 'smooth', block: 'start' });
});

document.querySelector('#open-drawer').addEventListener('click', function () {
  let drawer = document.querySelector('#bottom-drawer');
  if (drawer.classList.contains('open')) {
    event.target.innerText = event.target.dataset.closed;
    drawer.classList.remove('open');
    document.querySelector('article').classList.remove('drawer-up');
  } else {
    event.target.innerText = event.target.dataset.open;
    drawer.classList.add('open');
    document.querySelector('article').classList.add('drawer-up');
  }
});

document.querySelectorAll('.select').forEach((select) => {
  select.addEventListener('click', function () {
    //if it's closed open it
    if (event.currentTarget.classList.contains('open')) {
      if (
        event.target !== event.currentTarget &&
        !event.target.classList.contains('selected')
      ) {
        event.currentTarget
          .querySelector('.selected')
          .classList.remove('selected');
        event.target.classList.add('selected');
        if (select.id == 'sort') {
          reSort(event.target.dataset.value);
        } else if (select.id == 'filter') {
          currentFilter = event.target.dataset.value;
          clearAndPopulate();
        }
      }
      event.currentTarget.classList.remove('open');
    } else {
      document.querySelector('.select.open')?.classList.remove('open');
      event.currentTarget.classList.add('open');
    }

    // if it's open check whether it's the current one
  });
});

function filterOfrendas(val) {
  return currentFilter == 'all' || val.type == currentFilter;
}

function reSort(val) {
  switch (val) {
    case 'recent':
      ofrendas = sort_recent;
      break;
    case 'alphabetical':
      if (sort_alphabetical.length < 1)
        sort_alphabetical = [...sort_recent].sort(function (a, b) {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
        });
      ofrendas = sort_alphabetical;
      break;
    case 'reverse-alphabetical':
      if (sort_reverse_alphabetical.length < 1)
        sort_reverse_alphabetical = [...sort_recent].sort(function (a, b) {
          return a.name < b.name ? 1 : a.name > b.name ? -1 : 0;
        });
      ofrendas = sort_reverse_alphabetical;
      break;
  }
  clearAndPopulate();
}

// sortField.addEventListener('change', function () {

// });

function clearAndPopulate() {
  document.querySelectorAll('.card-container:not(.first)').forEach((el) => {
    el.remove();
  });

  document.querySelectorAll('.card-container .card').forEach((el) => {
    el.remove();
  });

  loaded = 0;
  loadMoreOfrendas(true);
}

//item generation

function loadMoreOfrendas(first = false) {
  const batchContainer = first
    ? document.querySelector('.card-container.first')
    : document.createElement('div');
  if (!first) batchContainer.className = 'card-container';

  let filtered = ofrendas.filter(filterOfrendas);

  let max = Math.min(filtered.length, loaded + 30);
  for (let i = loaded; i < max; i++) {
    const ofrenda = filtered[i];

    const newCard = createCard(ofrenda);
    batchContainer.appendChild(newCard);
  }

  if (!first) container.appendChild(batchContainer);
  // let marigold = document.createElement('figure');
  // marigold.className = 'marigold lazy-bg-loaded';
  // marigold.ariaHidden = 'true';
  // container.append(marigold);

  loaded = loaded + 30;
  container.dataset.loaded = loaded;
}

function createCard(ofrenda) {
  const newCard = cloner.cloneNode(true);
  const alt = frame_alts[ofrenda.frame - 1].replace('NAME', ofrenda.name);
  newCard.ariaLabel = alt;
  const imgName = 'img-' + ofrenda.id + '-320';
  let sources = Array.from(newCard.querySelectorAll('picture source'));

  sources[0].dataset.srcset = images.avif[ofrenda.index];
  sources[1].dataset.srcset = images.webp[ofrenda.index];

  observer.observe(sources[0]);
  observer.observe(sources[1]);

  newCard.querySelector('img').srcset = images.png[ofrenda.index];

  newCard.querySelector('img').alt = alt;
  newCard.querySelector(
    '.submission-name'
  ).innerText = `- ${ofrenda.s_first_name} ${ofrenda.s_last_name}`;
  newCard.querySelector('.submission-location').innerText = ofrenda.location;
  newCard.querySelector('.message').innerText = ofrenda.message;
  newCard.querySelector('.cardName').innerText = ofrenda.name;
  return newCard;
}

//for filtering:
// create html multiple choice for recent / A-Z / Z-A and checkboxes for people and pets

//------------------

////////////////////////////////////
/// MAKE CARDS REACT TO KEYBOARD ///
////////////////////////////////////

var cards = document.querySelectorAll('div.card');

function removeActive() {
  cards.forEach(function (i) {
    i.classList.remove('active');
    var children = i.children;
    children[0].classList.remove('active');
    children[1].classList.remove('active');
  });
}

//event listener that adds active class to the card being pressed
cards.forEach(function (item) {
  item.addEventListener('keypress', function (i) {
    removeActive();
    this.classList.add('active');
    var childrenDivs = this.children;
    childrenDivs[0].classList.add('active');
    childrenDivs[1].classList.add('active');
  });
});
